import { useEffect, useRef, useState } from "react";
import { Box } from "@chakra-ui/react";

const ELFSIGHT_SRC = "https://static.elfsight.com/platform/platform.js";

/**
 * Google reviews, embedded via Elfsight.
 *
 * The widget platform is ~525 KiB of third-party JavaScript and was measured
 * blocking the main thread for ~245 ms. Loading it on mount pushed the hero
 * image's paint out by roughly two seconds even though the reviews sit well
 * below the fold.
 *
 * So the script is only injected once the section comes within 400px of the
 * viewport, and only once per page load. Everything above the fold now renders
 * without waiting on it.
 */
const Testimonials = () => {
  const containerRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "400px" }
    );
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!shouldLoad) return;
    // The platform script registers globals and rewrites the DOM outside
    // React's control, so it must not be injected twice — and must not be torn
    // down on unmount the way the previous version did.
    if (document.querySelector(`script[src="${ELFSIGHT_SRC}"]`)) return;

    const script = document.createElement("script");
    script.src = ELFSIGHT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, [shouldLoad]);

  return (
    <Box id="review" ref={containerRef}>
      <div>
        <div
          className="elfsight-app-8ab0bdf4-c6d3-4599-bc73-dde6c55bc733"
          data-elfsight-app-lazy
          style={{
            maxWidth: "100vw",
            margin: "0 auto",
            padding: "50px",
            paddingTop: "80px",
            // Reserve space so the widget arriving doesn't shove the page down.
            minHeight: "420px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#f5d5bc",
          }}
        ></div>
      </div>
    </Box>
  );
};

export default Testimonials;
